import { render, staticRenderFns } from "./LoanCreation.vue?vue&type=template&id=fb061742&scoped=true&"
import script from "./LoanCreation.vue?vue&type=script&lang=js&"
export * from "./LoanCreation.vue?vue&type=script&lang=js&"
import style0 from "./LoanCreation.vue?vue&type=style&index=0&id=fb061742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb061742",
  null
  
)

export default component.exports